import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import QuickSearchAutosuggest from '@Containers/QuickSearchAutosuggest';
import useStaticExamplesEnabled from '@Pages/QuickSearch/Components/BuildQuery/useStaticExamplesEnabled';
import wrapWithStaticExamples from '@Pages/QuickSearch/Components/RxSearchLabel/wrapWithStaticExamples';
import RxSearchLabel from '../../RxSearchLabel';

import './BuildQuerySearch.custom.scss';
import './BuildQuerySearch.theme.scss';

const QuickSearchAutosuggestWithStaticExamples = wrapWithStaticExamples(QuickSearchAutosuggest);

function BuildQuerySearch(props) {
  const { query, structurePreview, populateQuickSearch, updateInputText, searchByQuery } = props;
  const isStaticExamplesEnabled = useStaticExamplesEnabled();
  const handleKeyDown = (e) => {
    if (e.keyCode !== 13) {
      return;
    }
    searchByQuery();
  };

  return (
    <div className="build-query-search">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="id-quick-search-input" className="build-query-search__label">
        Search Reaxys
      </label>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div role="search" aria-label="Search reaxys properties" className="build-query-search__input" onKeyDown={handleKeyDown}>
        {isStaticExamplesEnabled ? (
          <QuickSearchAutosuggestWithStaticExamples inputValue={query.text} buildQuery={{ updateInputText, query }} />
        ) : (
          <QuickSearchAutosuggest inputValue={query.text} buildQuery={{ updateInputText, query }} />
        )}
        <Button
          type="button"
          disabled={!query?.text?.length && !structurePreview}
          onClick={searchByQuery}
          buttonConfig={{
            type: 'primary',
            size: 'md',
            label: 'Find',
            ariaLabel: `Quick search for ${query.text}`,
            e2eName: 'build-query-search',
            className: 'build-query-search__input_button',
          }}
          iconConfig={{
            name: 'chevron-right',
            size: 'md',
          }}
        />
      </div>
      {!isStaticExamplesEnabled ? <RxSearchLabel onSuffixClick={populateQuickSearch} /> : null}
    </div>
  );
}

BuildQuerySearch.propTypes = {
  query: PropTypes.object,
  structurePreview: PropTypes.string,
  populateQuickSearch: PropTypes.func.isRequired,
  updateInputText: PropTypes.func.isRequired,
  searchByQuery: PropTypes.func.isRequired,
};

export default BuildQuerySearch;
